import React, { useState, useEffect, Component, createRef } from 'react'
import { getScrollTop, throttle } from '@/utils/common'
import './index.less'
import { Popover } from 'antd'

const asiderBarTop = 800

class Asiderbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false,
    }
    this.asiderbarRef = createRef()
    this.scrollEvent = throttle(this.getScroll, 200)
  }

  componentDidMount() {
    // window.document.body.addEventListener('scroll', this.scrollEvent)
  }

  componentWillUnmount() {
    // window.document.body.removeEventListener('scroll', this.scrollEvent)
  }

  doRoof() {
    getScrollTop(0, 25)
  }

  getScroll() {
    getScrollTop().then((top) => {
      if (!this.state.show && top > asiderBarTop) {
        this.setState({ show: true })
      } else if (this.state.show && top < asiderBarTop) {
        this.setState({ show: false })
      }
    })
  }

  render() {
    return (
      <div className="shuqin-asiderbar" ref={this.asiderbarRef}>
        <div className='zsqz'>
          <Popover
            getPopupContainer={() => this.asiderbarRef.current}
            placement='left' 
            arrow={false}
            overlayInnerStyle={{ backgroundColor: 'transparent', boxShadow: 'unset', marginRight: '-38px' }}
            content={<img style={{ width: '360px', height: '360px' }} 
            src={require('../../assets/image/zsqz-qrcode.png')} />}>
            <img src={require('../../assets/image/icon_zsqz_phone.png')} />
          </Popover>
        </div>
        <div className="shuqin-asiderbar-content">
          {
            <div className="asiderbar-active">
              <img
                src={require('../../assets/image/contact.png')}
              ></img>
              <span>联系我们</span>
            </div>
          }
          <div className={`asiderbar-left`}>
            <div className="asiderbar-phone-box">
              <div className="asiderbar-phone-box-item">
                <p>联系电话</p>
                <p className="phone">0571-87292902</p>
              </div>
              <div className="asiderbar-phone-box-item">
                <p>商务邮箱</p>
                <p className="phone">Business@dataqin.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Asiderbar
